export const hasActiveFilters = (filters) => {
    const values = Array.isArray(filters)
        ? filters
        : Object.values(filters ?? {})

    return values.some((value) => {
        if (value === null || value === undefined) {
            return false
        }

        if (typeof value === 'string') {
            return value.trim().length > 0
        }

        if (typeof value === 'object') {
            return hasActiveFilters(value)
        }

        return true
    })
}

export const redirectClearingFilters = (ctx, extra = {}) => {
    const params = { clear_filters: 1, ...extra }
    ctx.redirect(ctx.route(ctx.currentRouteName, params))
}